module.exports = __webpack_public_path__ + "../panel-assets/img/FinPLLogo.d57b25ea.svg";